import { Component, OnInit, Input } from '@angular/core'
import { ApiService } from '../api.service'
import { LandingPageService } from '../landing-page.service';
import { Course } from '../course.model';
import { CourseVendor } from '../course-vendor.model'

@Component({
    selector: 'app-landing-page-course-vendors',
    templateUrl: './landing-page-course-vendors.component.html',
    styleUrls: ['./landing-page-course-vendors.component.scss']
})
export class LandingPageCourseVendorsComponent implements OnInit {
    @Input() course: Course;
    
    isActive:boolean = false;

    constructor(
        private apiService: ApiService,
        private landingPageService: LandingPageService,
    ) { }

    courseVendors: CourseVendor[] = [];
    total: number;
    isLoaded:boolean = false;
    loadingError:boolean = false;
    errorMsg:string = '';
    loadingMsg:string = '';

    ngOnInit() {
        this.getVendors()
    }

    getVendors(): void {
        this.loadingMsg = ''
        this.errorMsg = ''

        this.apiService.getCourseVendors(this.course, {status: "Active"}).subscribe(
            data => {
                this.courseVendors = data.map(courseVendor => new CourseVendor(courseVendor));
                this.isLoaded = true
            },
            error => {
                this.courseVendors = []
                this.loadingMsg = "An error occurred, and we were unable to load Vendors for this Course."
                this.isLoaded = true
            }
        )
    }

    open(): void {
        this.landingPageService.showVendors = true;
    }

    close(): void {
        this.landingPageService.showVendors = false;
    }

    get showVendors (){
        return this.landingPageService.showVendors;
    }
}
